import React from 'react'

import styles from './FormInputs.module.scss'

const FormInputs = ({ children }) => <div className={styles.formInputs}>{children}</div>

export default FormInputs
